import { z } from "zod";
export const DTOFigmaExportNodeFormat = z.enum(["HTML", "JSON"]);
export const DTOFigmaExportNodeConfiguration = z.object({
    format: DTOFigmaExportNodeFormat,
    minifyOutput: z.boolean().optional(),
    customFontUrls: z.string().array().optional(),
});
